'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage from "./io.intela.sites.digitalinternship.-Page.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_Page$$anon$2(\u03b4name$2, _$ordinal$2) {
  this.kB = null;
  this.kB = \u03b4name$2;
}
export { $c_Lio_intela_sites_digitalinternship_Page$$anon$2 as $c_Lio_intela_sites_digitalinternship_Page$$anon$2 };
$p = $c_Lio_intela_sites_digitalinternship_Page$$anon$2.prototype = new $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage.$h_Lio_intela_sites_digitalinternship_Page();
$p.constructor = $c_Lio_intela_sites_digitalinternship_Page$$anon$2;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_Page$$anon$2() {
}
export { $h_Lio_intela_sites_digitalinternship_Page$$anon$2 as $h_Lio_intela_sites_digitalinternship_Page$$anon$2 };
$h_Lio_intela_sites_digitalinternship_Page$$anon$2.prototype = $p;
$p.G = (function() {
  return 0;
});
$p.H = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.I = (function() {
  return this.kB;
});
$p.t = (function() {
  return this.kB;
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I(this.kB);
});
var $d_Lio_intela_sites_digitalinternship_Page$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_Page$$anon$2, "io.intela.sites.digitalinternship.Page$$anon$2", ({
  eW: 1,
  av: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1,
  V: 1,
  y: 1,
  N: 1,
  S: 1
}));
export { $d_Lio_intela_sites_digitalinternship_Page$$anon$2 as $d_Lio_intela_sites_digitalinternship_Page$$anon$2 };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Page$$anon$2.js.map
